<template>
  <div v-if="submitted">
    <div v-if="error" class="error-message"><p>Something went wrong, please try again later!</p></div>
    <div v-else class="success-message"><p>Thanks for submitted your enquiry! We will be in contact shortly.</p></div>
  </div>
  <!-- Contact Form -->
   <form class="vue-form" @submit.prevent="submit" v-else="submitted">
    <div class="error-message">
      <p v-show="!email.valid" >Please enter a valid email address.</p>
    </div>

    <fieldset>
      <legend>Contact Form</legend>
      <div>
        <label class="label" for="name">Name</label>
        <input type="text" name="name" id="name" required="" v-model="name">
      </div>
      <div>
        <label class="label" for="email">Email</label>
        <input type="email" name="email" id="email" required=""
               :class="{ email , error: !email.valid }"
               v-model="email.value">
      </div>
      <div>
        <label class="label" >Area of Guiding</label>
        <p class="select">
          <select class="guiding-area" v-model="selection.member">
						<option value="Rainbows">Rainbows</option>
						<option value="Brownies">Brownies</option>
            <option value="Guides">Guides</option>
            <option value="Rangers">Rangers</option>
            <option value="Guiding18">Guiding 18+</option>
            <option value="Trefoil">Trefoil</option>
					</select>
        </p>
      </div>
        <label class="label" for="textarea">Message</label>
        <textarea class="message" name="textarea" id="textarea" required="" 
                  v-model="message.text" 
                  :maxlength="message.maxlength"></textarea>
        <span class="counter">{{ message.text.length }} / {{ message.maxlength }}</span>
      </div>
      <div class="submit">
        <input type="submit" :value="submitText" :disabled="sending">
      </div>
    </fieldset>
  </form>

 <!-- <div class="debug">
    <pre><code>{{ $data }}</code></pre>
  </div>-->

</template>
<script>
import emailjs from 'emailjs-com';

var emailRegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export default {
  name: 'contact-form',
  props: {
  },
 data: function() {
    return {
      name: "",
      email: {
        value: "",
        valid: true
      },
      selection: {
        member: "",
      },
      message: {
        text: ``,
        maxlength: 255
      },
      submitted: false,
      error:false,
      submitText: 'Send Form',
      sending:false
    };
  },
  methods: {
    // submit form handler
    submit: function(e) {
      this.sending = true;
      this.submitText = 'Sending...'
      let self =this;
      let content = 'Contact:' +  this.email.value + ' Message:' + this.message.text;
      let templateParams = {
          name: this.name,
          email: this.email.value,
          area:this.selection.member,
          content: content
      }
      
    
     emailjs.send("gmail", "girl_guiding_template", templateParams, 'user_AQADFajOlODUNZMqsXKaP').then(function(response) {
        console.log('SUCCESS!', response.status, response.text);
        self.submitted = true;
      }, function(err) {
        self.submitted = true;
        self.error = true;
        console.log('FAILED...', err);
      });
    },
    // validate by type and value
    validate: function(type, value) {
      if (type === "email") {
        this.email.valid = this.isEmail(value) ? true : false;
      }
    },
    // check for valid email adress
    isEmail: function(value) {
      return emailRegExp.test(value);
    },
    // check or uncheck all
    checkAll: function(event) {
      this.selection.features = event.target.checked ? this.features : [];
    }

  },
  watch: {
    // watching nested property
    "email.value": function(value) {
      this.validate("email", value);
    }
  }
}
</script>

<style lang="scss">
@import '@/app/styles/index.scss';

.vue-form {
  font-size: 16px;
  width: 100%;
  max-width:500px;
  padding: 15px 30px;
  border-radius: 4px;
  margin: 50px auto;
  background-color: #fff;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
  fieldset{
    border:0;
    .submit{ 
      padding-top:15px;
      width:50%;
      margin:auto;
      input{
        border: 1px solid #ffffff;
        border-radius:5px;
        background-color:$color-blue;
        color:white;
      }
    }
    .label{
      padding-top:15px;
    }
    div {
      
      input{
        border: 1px solid #dbdbdb;
        border-radius: 3px;
        padding: 10px;
        width: 100%;
        color: #363636;
        cursor: pointer;
      }
    }
    textarea{
      width:100%;
    }
  }
}
.select{
  width:100%;
  select{
    width:100%;
  }
}
.error-message {
  height: auto;
  margin: 0px;
  
  p {
    background: #e94b35;
    color: #ffffff;
    font-size: 1.4rem;
    text-align: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    border-radius: 0.25em;
    padding: 16px;
  }
}

.success-message {
  height: auto;
  margin: 0px;
  
  p {
    background-color: #d4edda;
    color: #155724;
    border-color: #c3e6cb;
    font-size: 1.4rem;
    text-align: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    border-radius: 0.25em;
    padding: 16px;
  }
}
input[type="submit"]:disabled {
  background: #dddddd;
}
</style>
